<template>
    <el-drawer title="结业考试" :visible="localVisible" size="60%" :with-header="true" :close-on-click-modal="false"
        :close-on-press-escape="true" @close="handleClose">
        <div class="drawer-content">
            <el-card v-if="currentExamDetail" class="chapter-section" shadow="hover" style="margin-bottom: 20px;">
                <div class="section-header" style="display:flex;justify-content:space-between;align-items:center;">
                    <h3 style="margin:0;">{{ currentExamDetail.questionBankName }}</h3>
                    <span style="color:#409EFF;">总分：{{ currentExamDetail.totalScore }}，及格分：{{
                        currentExamDetail.passScore }}</span>
                </div>
                <div class="section-content" style="margin-top:12px;">
                    <el-table :data="currentExamDetail.questionConfigs" border style="width: 100%;">
                        <el-table-column prop="type" label="题型" width="100">
                            <template slot-scope="scope">
                                <span v-if="scope.row.type == 1">单选题</span>
                                <span v-else-if="scope.row.type == 2">多选题</span>
                                <span v-else-if="scope.row.type == 3">判断题</span>
                                <span v-else>其他</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="questionsNumber" label="题目数量" width="100" />
                        <el-table-column prop="questionsScore" label="每题分值" width="100" />
                    </el-table>
                </div>
                <div style="text-align:right;margin-top:24px;">
                    <el-button type="primary" @click="startExam">开始考试</el-button>
                </div>
            </el-card>
            <el-empty v-else description="暂无可用试卷" />
        </div>
    </el-drawer>
</template>

<script>
import { QuestionsConfig, bizTypeExamination } from '@/api/course'
export default {
    name: 'ExamDrawer',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        courseId: {
            type: [String, Number],
            required: true
        },
        majorId: {
            type: [String, Number],
            default: ''
        },
        level: {
            type: String,
            default: ''
        },
        direction: {
            type: String,
            default: ''
        },
        province: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            localVisible: this.visible,
            currentExamDetail: null
        }
    },
    watch: {
        visible(val) {
            this.localVisible = val
            if (val) {
                this.fetchExamDetail()
            } else {
                this.currentExamDetail = null
            }
        },
        courseId(val) {
            if (this.localVisible && val) {
                this.fetchExamDetail()
            }
        }
    },
    methods: {
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        },
        fetchExamDetail() {
            if (!this.courseId || !this.majorId) return
            const params = {
                majorId: this.majorId,
                level: this.level,
                province: this.province,
                quizType: '5',
                direction: this.direction
            }
            QuestionsConfig(params).then(res => {
                if (res.code === 200 && res.data && res.data.length > 0) {
                    this.currentExamDetail = res.data[0]
                } else {
                    this.currentExamDetail = null
                }
            }).catch(() => {
                this.currentExamDetail = null
            })
        },
        async startExam() {
            if (!this.currentExamDetail || !this.currentExamDetail.id) {
                this.$message.error('试卷信息有误')
                return
            }
            const params = {
                majorId: this.currentExamDetail.majorId,
                bizType: '5',
                quizConfigId: this.currentExamDetail.id
            }
            try {
                const res = await bizTypeExamination(params)
                if (res.code === 200 && res.data && res.data.trainQuestionList) {
                    localStorage.removeItem('trainQuestionList')
                    localStorage.setItem('examData', JSON.stringify(res.data))
                    this.$router.push({
                        name: 'ExamPage',
                        query: {
                            quizConfigId: this.currentExamDetail.id,
                            majorId: this.currentExamDetail.majorId,
                            level: this.currentExamDetail.level,
                            quizType: this.currentExamDetail.quizType,
                            direction: this.currentExamDetail.direction
                        }
                    })
                    this.handleClose()
                } else {
                    this.$message.error(res.msg || '获取试卷失败')
                }
            } catch (e) {
                this.$message.error('获取试卷失败')
            }
        }
    }
}
</script>

<style scoped>
.drawer-content {
    padding: 24px;
}
</style>